//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import type { PresentationCardsResult } from './models/PresentationCardsResult';
import { Utilities } from './Utilities';

export class HomeClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        getPresentationCards: (): string => {
            let clientRequestUrl = '/api/v1/home/presentation-cards';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    };

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Get home presentation cards
     * @return OK
     */
    async getPresentationCards(): Promise<PresentationCardsResult> {
        const clientRequestUrl = this.baseUrl + this.routes.getPresentationCards();

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<PresentationCardsResult>(_response, false, []);
    }
}
